import { userService } from "../services";
import config from "../config/config";

export const ScheduleMasterAction = {
  uploadScheduleMaster,
  fetchScheduleMasterList,
  deleteScheduleMaster,
  deleteScheduleMasterBulk,
};

async function uploadScheduleMaster(payload) {
  try {
    // POST  dpl/upload  (multipart/form-data)
    let apiEndpoint = `${config.baseUrl}${config.apiName.uploadScheduleMaster}`;
    let response = await userService.postFIle(apiEndpoint, payload);
    if (response && response?.status === 200) {
      return response;
    } else {
      console.log(response);
      if (response?.status !== 500) {
        // alert(response?.data?.message);
      }
      if (response?.status === 401) {
        alert(response?.data?.message);
      }
      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}

async function fetchScheduleMasterList(payload) {
  try {
    // GET  api/v1/get/schedule/trips?vehicleId=101&vehicleNumber=DL1LAQ1054&page=0&size=10
    const params = new URLSearchParams();
    if (payload.vehicleId) params.append("vehicleId", payload.vehicleId);
    // if (payload.fplId) params.append("fplId", payload.fplId);
    params.append("page", payload.pageNo || 0);
    params.append("size", payload.pageSize || 10);

    let apiEndpoint = `${config.baseUrl}${config.apiName.scheduleMasterList}?${params.toString()}`;
    let response = await userService.get(apiEndpoint);
    if (response && response?.status === 200) {
      return response;
    } else {
      console.log(response);
      if (response?.status !== 500) {
        // alert(response?.data?.message);
      }
      if (response?.status === 401) {
        alert(response?.data?.message);
      }
      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}

async function deleteScheduleMaster(payload) {
  try {
    // GET  dpl/v1/delete/schedule_trip?scheduleTripId=1
    let apiEndpoint = `${config.baseUrl}${config.apiName.deleteScheduleMaster}?scheduleTripId=${payload.scheduleTripId}&userId=${payload.userId}`;
    let response = await userService.get(apiEndpoint);
    if (response && response?.status === 200) {
      return response;
    } else {
      console.log(response);
      if (response?.status !== 500) {
        // alert(response?.data?.message);
      }
      if (response?.status === 401) {
        alert(response?.data?.message);
      }
      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}

// ── New: Delete multiple trips at once ──
async function deleteScheduleMasterBulk(payload) {
  try {
    // GET  dpl/v1/delete/schedule_trip?scheduleTripId=12752,12751,12750
    const tripIds = Array.isArray(payload.tripIds) 
      ? payload.tripIds.join(",") 
      : payload.tripIds;
    
    let apiEndpoint = `${config.baseUrl}${config.apiName.deleteScheduleMaster}?scheduleTripId=${tripIds}&userId=${payload.userId}`;
    let response = await userService.get(apiEndpoint);
    if (response && response?.status === 200) {
      return response;
    } else {
      console.log(response);
      if (response?.status !== 500) {
        // alert(response?.data?.message);
      }
      if (response?.status === 401) {
        alert(response?.data?.message);
      }
      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}